import React from 'react';
import axios from 'axios';

import type { InboxConfigOption } from '../InboxSelectionDialog/InboxSelectionDialog';
import { InboxSelectionDialog } from '../InboxSelectionDialog/InboxSelectionDialog';

interface ReassignInboxDialogProps {
  inboxItemId: number;
  onClose: () => void;
  onReassigned: () => void;
}

export const ReassignInboxDialog: React.FC<ReassignInboxDialogProps> = ({ inboxItemId, onClose, onReassigned }) => {
  const handleSave = async (inbox: InboxConfigOption) => {
    await axios.post(`/api/v1/fnol_inbox/inbox/${inboxItemId}/reassign_inbox`, {
      target_sub_organization_id: inbox.sub_organization_id,
      target_lob: inbox.lob,
    });
    onReassigned();
  };

  return (
    <InboxSelectionDialog
      title="Reassign to another Inbox"
      description="Choose the sub-org to reassign the FNOL"
      fetchUrl={`/api/v1/fnol_inbox/inbox/${inboxItemId}/available_inboxes`}
      onSave={handleSave}
      onClose={onClose}
    />
  );
};
